export function formatDuration(seconds: number): string {
  if (seconds < 60) return `${seconds}秒`
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  if (mins < 60) return `${mins}分${secs}秒`
  const hrs = Math.floor(mins / 60)
  const remainMins = mins % 60
  return `${hrs}時${remainMins}分${secs}秒`
}
